import React from "react";
import Page from "../Components/Page";
import ResetPasswordForm from "../features/auth/ResetPasswordForm";

export default function ResetPassword() {
  return (
    <Page title={"Reset Password"}>
      <ResetPasswordForm />
    </Page>
  );
}
